/**
 * WordPress dependencies.
 */
 import { Component, Fragment } from '@wordpress/element';
 import { compose } from '@wordpress/compose';
 import { withDispatch } from '@wordpress/data';
 import { __ } from '@wordpress/i18n';
 import { Icon } from '@wordpress/components';
 
 import './editor.scss';

 /**
  * Inner dependencies.
  */
import './plugin-setting-sidebar/index.js';


import TemplatesModal from './plugin-setting-sidebar/template-model';
 
 class Edit extends Component {
	 constructor( props ) {
		 super( props );
		 // bind function
		 this.getLayoutsSelector = this.getLayoutsSelector.bind( this );
 
		 this.state = {
			 isModelOpen: false,
		 };
	 }
	 getLayoutsSelector() {
		 const {
			 clientId,
			 attributes,
			 removeBlock,
		 } = this.props;
		 return (
			 <>
				 { attributes.isTemplatesModalOnly || this.state.isTemplatesModalOpen ? (
					 <TemplatesModal
						 onRequestClose={ () => {
							 this.setState( {
								 isTemplatesModalOpen: false,
							 } );
							 if ( attributes.isTemplatesModalOnly ) {
								 removeBlock( clientId );
							 }
						 } }
						 replaceBlockId={ clientId }
					 />
				 ) : (
					 ''
				 ) }
			 </>
		 );
	 }
	 render() {

		 const openModal = () => {
			 this.setState( {
				 isTemplatesModalOpen: true,
			 } );
		 };
		 return (
			 <div className="templazee-browse-template">
				 { this.getLayoutsSelector() }
				 <button onClick={ () => openModal() }><Icon icon="admin-appearance" /> { __( 'Add Templates' ) }</button>
			 </div>
		 );
	 }
 }
 
 export default compose( [
	 withDispatch( ( dispatch ) => {
		 const { updateBlockAttributes, removeBlock, replaceInnerBlocks } = dispatch(
			 'core/block-editor'
		 );
 
		 return {
			 updateBlockAttributes,
			 removeBlock,
			 replaceInnerBlocks,
		 };
	 } ),
 ] )( Edit );
 